// utils/tracking.js
export const UTM_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid'
  ];
  
  export function getUtmParamsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmData = {};
    
    UTM_PARAMS.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        utmData[param] = value;
      }
    });
  
    return {
      ...utmData,
      landing_page: window.location.pathname,
      referrer: document.referrer || '',
      timestamp: new Date().toISOString()
    };
  }
  
  // Store mutations
  export const trackingMutations = {
    SET_TRACKING_DATA(state, data) {
      state.trackingData = [...state.trackingData, data];
    },
    CLEAR_TRACKING_DATA(state) {
      state.trackingData = [];
    }
  };
  
  // Store actions
  export const trackingActions = {
    captureTrackingData({ commit }) {
      const utmData = getUtmParamsFromUrl();
      
      // Only add new tracking data if we have UTM parameters or it's a new session
      if (Object.keys(utmData).length > 2) { // More than just landing_page and timestamp
        commit('SET_TRACKING_DATA', utmData);
      }
    },
    clearTrackingData({ commit }) {
      commit('CLEAR_TRACKING_DATA');
    }
  };
  
  // Store getters
  export const trackingGetters = {
    getAllTrackingData: state => state.trackingData,
    getLatestTrackingData: state => {
      return state.trackingData.length > 0 
        ? state.trackingData[state.trackingData.length - 1] 
        : null;
    }
  };